export const DEVICE_INFO = {
  GET_DEVICE_INFO: 'GET_DEVICE_INFO',
}
